<template>
  <EDropdown
    :visible="visible"
    class="notifications-dropdown"
    side="right"
  >
    <ENotificationItem
      v-for="notification in notifications"
      :key="notification.id"
      :locale="locale"
      :notification="notification"
      event-origin="center"
      class="notification"
    />
    <ELink :href="blogUrl" class="more">
      {{ readMoreLabel }}
    </ELink>
  </EDropdown>
</template>

<script>
import EDropdown from '~~/common/vue/components/dropdown';
import ELink from '~~/common/vue/components/link';
import ENotificationItem from './item';

export default {
  name: 'ENotificationList',
  components: {
    EDropdown,
    ELink,
    ENotificationItem,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    blogUrl: {
      type: String,
      required: true,
    },
    readMoreLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    locale() {
      return this.$store.state.global.locale;
    },
    notifications() {
      return this.$store.getters['notifications/get'];
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-dropdown {
  top: 100%;
  right: 0;

  @include tablet {
    top: calc(100% + #{$space-s});
    right: -$space-s;
  }

  &::after,
  &::before {
    right: $space-4l + $space-2s;
  }
}

.notification {
  @include divider('bottom');

  &:last-of-type {
    border-bottom: 0;
  }
}

.more {
  @include divider('top');

  display: block;
  padding: $space-s 0;
  font-size: $font-s;
  text-align: center;
  border-radius: 0 0 $border-radius-s $border-radius-s;
}
</style>
